module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_1.5e59effb.png";